/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect } from "react";
import { get, set } from "lodash";
export const AxeptioIntegration = () => {
  useEffect(() => {
    if (!get(window, 'axeptioSettings')) {
      set(window, 'axeptioSettings', {
        clientId: import.meta.env.VITE_AXEPTIO_CLIENT_ID,
        cookiesVersion: import.meta.env.VITE_AXEPTIO_COOKIES_VERSION,
      });

      (function (d, s) {
        const t: any = d.getElementsByTagName(s)[0];
        const e: any = d.createElement(s);
        e.async = true;
        e.src = "//static.axept.io/sdk-slim.js";
        t.parentNode.insertBefore(e, t);
      })(document, "script");
    }
  }, []);

  return null;
};
